import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringHistory } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';

import { IChangeMonitoringDTO } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { IChangeMonitoring } from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING_HISTORY } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringReturn {
	isLoadingChangeMonitoringHistory: boolean;
	changeMonitoringHistory: IChangeMonitoring[];
	countOfRecords: number;
}

export const useQueryChangeMonitoringHistory = (
	params: IChangeMonitoringDTO,
): IUseQueryChangeMonitoringReturn => {
	const {
		data,
		isInitialLoading: isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING_HISTORY, params],
		queryFn: extractQueryParams(getChangeMonitoringHistory),
		enabled: [params?.isActive, !!params.networkElementId],
		...refetchOptions,
	});

	return {
		isLoadingChangeMonitoringHistory: isLoading || isFetching,
		changeMonitoringHistory: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
